import { render } from "./CancelMandateCreate.vue?vue&type=template&id=3dc69968&scoped=true"
import script from "./CancelMandateCreate.vue?vue&type=script&lang=js"
export * from "./CancelMandateCreate.vue?vue&type=script&lang=js"

import "./CancelMandateCreate.vue?vue&type=style&index=0&id=3dc69968&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc69968"]])

export default __exports__